import axios from '../jslib/http'
import qs from 'qs'
import {request} from "../jslib/request";
const BASE_REQUEST = '/tms/contract'

export function getContractList (pageNo,pageSize,qName,qContractType) {
    const url = `${BASE_REQUEST}/getContract`
    var data = {
        pageNo:pageNo,
        pageSize:pageSize,
        qName:qName,
        qContractType:qContractType
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function saveContract(
    obj
) {
    const url = `${BASE_REQUEST}/saveContract`
    var data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function updateContract(
    obj
) {
    const url = `${BASE_REQUEST}/updateContract`
    var data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function delContract(
    id
) {
    const url = `${BASE_REQUEST}/delContract`
    var data = {
        contractid:id
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function passOrReject(
    contractid,
    status,
    remarks
) {
    const url = `${BASE_REQUEST}/passOrReject`
    var data = {
        contractid:contractid,
        status:status,
        remarks:remarks
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getContractByIds(params) {
    return axios({
      params,
      url: `${BASE_REQUEST}/getContractByIds`,
      method: 'get',
    })
  }


export function getShipContractListPage(params) {
  return request({
    data:params,
    url: `${BASE_REQUEST}/getShipContractListPage`,
    method: 'get',
  })
}
